//
// the controller for the search dealerships page
//
dealershipModule.controller('DealershipSearchController',
    ['$scope', '$location', 'dealershipService', 'SearchFilters', 'commonTLCService', 'imSessionVarsService',
        'routes', 'erateSessionVarsService','commonTLCService','rateQuoteCoordService','quoteIntegrationService', 'erateService',
        'TLCError','AppErrorCodes','vehicleDefinitionService','AppSettings', 'providerFeaturesService',
        'usageEventsService',
    function ($scope, $location, dealershipService, SearchFilters, commonTLCService, imSessionVarsService,
              routes, erateSessionVarsService,commonTLCService, rateQuoteCoordService, quoteIntegrationService, erateService,
            TLCError,AppErrorCodes, vehicleDefinitionService,AppSettings, providerFeaturesService,
            usageEventsService
    ) {

        $scope.dealerships = [];
        $scope.includeAll = false;
        $scope.totalItems = 0;
        $scope.currentPageSize = 0;
        $scope.currentPage = 0;
        $scope.pagesLength = 1;
        $scope.pagesLengthArray = [];
        $scope.currentSortType = 'dealershipName';
        $scope.currentSortOrder = 'asc';
        $scope.currentDealerIMId = imSessionVarsService.getCurrentDealerIMId();
        // filters
        $scope.filters = new SearchFilters();

        init();
        $scope.$on('$viewContentLoaded', function() {
            refresh();
        });

        $scope.introShowcaseVal = null;

        function init() {
            $scope.currentPageSize = 20;
            $scope.currentPage = 0;
            prefillStates();
            providerFeaturesService.getProviderApplicationSetting('ShowcaseLiteIntro', 'false')
            .then(function(val) {
                $scope.introShowcaseVal = val;
            });

        }

        $scope.searchWithFilters = function () {
            $scope.currentPage = 0;
            refresh();
        };

        $scope.pageChanged = function () {
            refresh();
        };
        $scope.inputReset = angular.copy($scope.filters); // references all available filters with empty values to reset form with clearInputs

        $scope.clearInputs = function () {
            angular.copy($scope.inputReset, $scope.filters);
            $scope.filters.state = ""; // forces md-select to go back to default "select" option then refreshes results
            $scope.searchWithFilters();
        };

        function prefillStates() {
            commonTLCService.getStates()
                .then(function (response) {
                     $scope.states = response;
                }, function (response) {
                    throw new TLCError(new Error(response),AppErrorCodes.DealerSearchController_LoadStatesError);
                });
        }

        function refresh() {
            $scope.dealerships = [];
            doSearch($scope.currentPage, $scope.currentPageSize);
        }

        function sort() {
            $scope.dealerships = [];
            doSearch(0, (($scope.currentPage + 1) * $scope.currentPageSize));
        }

        function doSearch(page, pagesize) {
            $scope.busy = true;

            dealershipService.searchDealerships(page, $scope.currentPageSize, $scope.currentSortType, $scope.currentSortOrder, $scope.filters)
                .then(function (response) { // resolved
                    $scope.dealerships = $scope.dealerships.concat(response.ItemList);
                    $scope.totalItems = response.TotalItemCount;
                    $scope.pagesLength = Math.ceil($scope.totalItems / $scope.currentPageSize);
                    $scope.pagesLengthArray = [];
                    for (var index = 0; index < $scope.pagesLength; index++) {
                        $scope.pagesLengthArray.push(index);
                    }
                    $scope.dealerships = [];
                    $scope.dealerships = response.ItemList;
                    $scope.currentPage = page;
                    $scope.searching = false;

                }, function (response) { // rejected
                    throw new TLCError(new Error(response),AppErrorCodes.DealerSearchController_GeneralError);
                }, function (response) { // notify
                }).finally(function () {
                    $scope.busy = false;
                });
        }

        $scope.sortToggle = function (sortType) {
            if ($scope.currentSortType === sortType) {
                toggleSortOrder();
            } else {
                $scope.currentSortType = sortType;
            }
            sort();
        };

        function toggleSortOrder() {
            if ($scope.currentSortOrder === "asc") {
                $scope.currentSortOrder = "dsc";
            } else {
                $scope.currentSortOrder = "asc";
            }
        }

        $scope.selectDealership = function (dealership) {
            // Todo: next line and dealershipService needs to be refactored. Dealership service should not maintain any state information.
            dealershipService.dealershipInfo.name = dealership.name;

            usageEventsService.dealerChanges(dealership.id);

            var usr = imSessionVarsService.getCurrentIMUser();
            var provcode = imSessionVarsService.getCurrentProviderCode();

            try {
                commonTLCService.setupEssentialDealerVars(dealership)
                    .then(function() {
                        //clear out any "stale" state information
                        quoteIntegrationService.clearIntegrationData();
                        rateQuoteCoordService.startNewQuoteSession(true,true,true,true);
                        vehicleDefinitionService.vehicleDetailsData.ready = false;

                        if (($scope.introShowcaseVal || 'false').toUpperCase() == 'TRUE')
                            $location.url(routes.showcaseLiteRedirect);
                        else
                            $location.url(routes.createQuote);
                    }),
                    function(err) {
                        // This should never happen
                        // Todo: do something with this error. Currently, it is just being thrown as an exception that gets lost.
                        throw new Error(err);
                    }

            }
            catch (ex) {
                // This should not happen
                switch (ex) {
                    case "ACCOUNT-NOT-FOUND":
                        throw new Error('Could not find dealer account code for dealer: ' + dealership.name);
                    case "SPANID-NOT-FOUND":
                        throw new Error('Could not find dealer SPAN id for  dealer: ' + dealership.name);
                }
                throw ex;
            }
        };

        $scope.paginationSearch = function(page, pageSize){
            doSearch(page, pageSize);
        }
    }
]);
